import cloneDeep from 'lodash/cloneDeep';
import { mergedCopy } from '../utils/objects';

export default function(merged, pending) {
  const {
    bitrates,
    detection,
    ecdn10,
    ecdn11,
    events,
    general,
    log,
    localityData,
    priming
  } = merged;
  pending = cloneDeep(pending);

  general.hb = (general.hb || []).concat(pending.general.t);
  delete pending.general.t;
  delete pending.general.critical;
  delete pending.general.expedited;

  bitrates.data.push(...pending.bitrates.data);
  events.data.push(...pending.events.data);
  detection.data.push(...pending.detection.data);
  priming.data.push(...pending.priming.data);
  log.data.push(...pending.log.data);

  return {
    general: mergedCopy(general, pending.general),
    ecdn10: mergedCopy(ecdn10, pending.ecdn10),
    ecdn11: mergedCopy(ecdn11, pending.ecdn11),
    localityData: mergedCopy(localityData, pending.localityData),
    bitrates,
    events,
    detection,
    log,
    priming
  };
}
